var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container visitPlanAdd" },
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.goBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _c(
            "div",
            { staticClass: "searchBox_top" },
            [
              [
                _vm.isSave
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.MsvDraft,
                            expression: "MsvDraft",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.saveVisitPlan("visitPlanFrom")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
                    )
                  : _vm._e(),
                _vm.isSubmit
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.MsvSubmit,
                            expression: "MsvSubmit",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitVisitPlan("visitPlanFrom")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.submit")))]
                    )
                  : _vm._e(),
              ],
              _vm.isActive
                ? [
                    _c("br"),
                    _c(
                      "label",
                      {
                        staticStyle: { "font-size": "12px", color: "#F56C6C" },
                      },
                      [_vm._v(_vm._s(_vm.$t("visitPlan.operationTips")))]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-form",
            {
              ref: "visitPlanFrom",
              attrs: {
                model: _vm.visitPlanFrom,
                rules: _vm.queryConditionRules,
                inline: "",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.Number"),
                            prop: "msvNo",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", placeholder: "保存后生成" },
                            model: {
                              value: _vm.visitPlanFrom.msvNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.visitPlanFrom, "msvNo", $$v)
                              },
                              expression: "visitPlanFrom.msvNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.Year"),
                            prop: "year",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "year",
                              disabled: _vm.yearStatus,
                              clearable: "",
                              "value-format": "yyyy",
                              placeholder: "选择年",
                            },
                            model: {
                              value: _vm.visitPlanFrom.year,
                              callback: function ($$v) {
                                _vm.$set(_vm.visitPlanFrom, "year", $$v)
                              },
                              expression: "visitPlanFrom.year",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("visitPlan.Remark"),
                            prop: "remarks",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              disabled: _vm.isDisabled,
                              maxlength: "200",
                            },
                            model: {
                              value: _vm.visitPlanFrom.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.visitPlanFrom, "remarks", $$v)
                              },
                              expression: "visitPlanFrom.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "计划明细", name: "first" } },
            [
              _c(
                "div",
                { staticClass: "toolsBox" },
                [
                  _vm.isNew
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.MsvAddPlanDetail,
                              expression: "MsvAddPlanDetail",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.addPlanDetail },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.addNew")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.MsvInactive,
                          expression: "MsvInactive",
                        },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.inactive },
                    },
                    [_vm._v("Inactive")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "tableList",
                  attrs: {
                    data: _vm.tableList,
                    border: "",
                    fit: "",
                    "max-height": "380",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", fixed: "", "min-width": "55" },
                  }),
                  _c("el-table-column", {
                    attrs: { type: "index", "min-width": "55", label: "序号" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "type",
                      label: _vm.$t("visitPlan.Type"),
                      "min-width": "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "category",
                      label: _vm.$t("visitPlan.Category"),
                      "min-width": "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "supplierName",
                      label: _vm.$t("visitPlan.SupplierFacility"),
                      "min-width": "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "responsibleCqs",
                      label: _vm.$t("visitPlan.ResponsibleCQS"),
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("PickupUser", {
                              attrs: {
                                title: "选择人员",
                                inputStatus: _vm.inputStatus,
                                placeholder: "请输入负责人",
                              },
                              on: {
                                value: function ($event) {
                                  scope.row.responsibleCqs
                                    ? "scope.row.responsibleCqs"
                                    : " "
                                },
                              },
                              model: {
                                value: scope.row.responsibleCqs,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "responsibleCqs", $$v)
                                },
                                expression: "scope.row.responsibleCqs",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "riskLevel",
                      label: _vm.$t("visitPlan.OverallRiskLevel"),
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticClass: "handle-input",
                                attrs: { disabled: _vm.inputStatus },
                                on: {
                                  change: function ($event) {
                                    return _vm.riskLevelChange(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.riskLevel,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "riskLevel", $$v)
                                  },
                                  expression: "scope.row.riskLevel",
                                },
                              },
                              _vm._l(_vm.riskLevelList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.code, value: item.code },
                                })
                              }),
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "frequency",
                      label: _vm.$t("visitPlan.Frequency"),
                      "min-width": "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: scope.row.frequency,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "frequency", $$v)
                                },
                                expression: "scope.row.frequency",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "monthOne",
                      label: "Month1",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "month",
                                placeholder: "请选择",
                                format: "yyyy-MM",
                                "value-format": "yyyy-MM",
                                disabled: _vm.setMonth1Disabled(scope.row),
                              },
                              model: {
                                value: scope.row.monthOne,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "monthOne", $$v)
                                },
                                expression: "scope.row.monthOne",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "monthOneStatusI18n",
                      label: "Month1状态",
                      "min-width": "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "monthTwo",
                      label: "Month2",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "month",
                                placeholder: "请选择",
                                "value-format": "yyyy-MM",
                                disabled: _vm.setMonth2Disabled(scope.row),
                              },
                              model: {
                                value: scope.row.monthTwo,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "monthTwo", $$v)
                                },
                                expression: "scope.row.monthTwo",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "monthTwoStatusI18n",
                      label: "Month2状态",
                      "min-width": "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "remark",
                      label: _vm.$t("visitPlan.Remark"),
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                disabled:
                                  _vm.setMonth1Disabled(scope.row) &&
                                  _vm.setMonth2Disabled(scope.row),
                              },
                              model: {
                                value: scope.row.remark,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "remark", $$v)
                                },
                                expression: "scope.row.remark",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "creater",
                      label: _vm.$t("visitPlan.CreateUser"),
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("visitPlan.CreateDate"),
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "updater",
                      label: _vm.$t("visitPlan.UpdateUser"),
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "updateDate",
                      label: _vm.$t("visitPlan.UpdateDate"),
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.updateDate,
                                  "YYYY-MM-DD"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("visitPlan.ModifyLog"), name: "second" } },
            [
              _c(
                "el-table",
                {
                  ref: "logList",
                  attrs: { data: _vm.logList, border: "", fit: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "describe",
                      label: _vm.$t("common.description"),
                      width: "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "action",
                      label: _vm.$t("common.operation"),
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "detail",
                      label: _vm.$t("common.ModifyContent"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("common.OperationTime"),
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "creater",
                      label: _vm.$t("common.OperatorName"),
                      width: "100",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "el-dialog": "",
            title: _vm.$t("visitPlan.AddPlanDetails"),
            visible: _vm.addPlanDetailsVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addPlanDetailsVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "searchBox" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  attrs: {
                    model: _vm.queryCondition,
                    inline: "",
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Type", prop: "type" } },
                    [
                      !_vm.isHGS
                        ? _c(
                            "el-select",
                            {
                              on: { change: _vm.typeChange },
                              model: {
                                value: _vm.queryCondition.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "type", $$v)
                                },
                                expression: "queryCondition.type",
                              },
                            },
                            _vm._l(_vm.typeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseValue,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm.isHGS
                        ? _c("el-input", {
                            attrs: { readonly: "" },
                            model: {
                              value: _vm.queryCondition.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "type", $$v)
                              },
                              expression: "queryCondition.type",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Facility", prop: "supplier" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryCondition.supplier,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryCondition, "supplier", $$v)
                          },
                          expression: "queryCondition.supplier",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.Categorylevel
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category level1 Name",
                              prop: "categoryLevel1Name",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { clearable: "", readonly: "" },
                              model: {
                                value: _vm.queryCondition.categoryLevel1Name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "categoryLevel1Name",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.categoryLevel1Name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Category level2 Name",
                              prop: "categoryLevel2Name",
                            },
                          },
                          [
                            _c("el-autocomplete", {
                              ref: "elautocomplete",
                              staticClass: "inline-input",
                              attrs: {
                                "fetch-suggestions": _vm.querySearch,
                                clearable: "",
                                placeholder: "请输入内容",
                              },
                              on: { select: _vm.name2Change },
                              model: {
                                value: _vm.queryCondition.categoryLevel2Name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "categoryLevel2Name",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.categoryLevel2Name",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.restQueryFormThis2 },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.toggleSelection },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.Deselected")))]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "toolsBox" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "tableList2",
              attrs: {
                data: _vm.tableList2,
                border: "",
                fit: "",
                "row-key": (row) => {
                  return (
                    row.tmSupplierId +
                    row.type +
                    row.categoryLevel2Code +
                    row.categoryLevel3Code
                  )
                },
                height: "300",
              },
              on: { "selection-change": _vm.selectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  "min-width": "55",
                  "reserve-selection": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "supplierCode",
                  label: _vm.$t("visitPlan.FactoryNo"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "supplierName",
                  label: _vm.$t("visitPlan.FactoryName"),
                },
              }),
              _vm.Categorylevel
                ? [
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "parentSupplierCode",
                        label: _vm.$t("visitPlan.SupplierNo"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "parentSupplierName",
                        label: _vm.$t("visitPlan.SupplierName"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "dcCategory.categoryLevel1Name",
                        label: "Category level1 Name",
                        "min-width": "130",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "dcCategory.categoryLevel2Name",
                        label: "Category level2 Name",
                        "min-width": "130",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "原因", visible: _vm.ReasonVisible, width: "40%" },
          on: {
            "update:visible": function ($event) {
              _vm.ReasonVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ReasonForm",
              attrs: {
                model: _vm.ReasonForm,
                rules: _vm.ReasonFormRules,
                inline: "",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "comments",
                  attrs: {
                    label: "请填写原因 ",
                    "label-width": "120",
                    prop: "comments",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { maxlength: "100" },
                    model: {
                      value: _vm.ReasonForm.comments,
                      callback: function ($$v) {
                        _vm.$set(_vm.ReasonForm, "comments", $$v)
                      },
                      expression: "ReasonForm.comments",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.ReasonVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.defineInactive("ReasonForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }